export const chassisTypes = ['Bus', 'Truck'] as const;

export type ChassisType = (typeof chassisTypes)[number];

export const isChassisType = (value: string): value is ChassisType => chassisTypes.includes(value as ChassisType);
